import { useState, useEffect } from "react";
import { animateScroll } from "react-scroll";
import { MdExpandLess } from "react-icons/md";
import {
  FaFacebookSquare,
  FaLinkedin,
  FaTwitterSquare,
  FaVimeoSquare,
  FaTumblrSquare,
  FaHeart,
} from "react-icons/fa";

const Footer = ({ theme }) => {
  const [scroll, setScroll] = useState(0);
  const [top, setTop] = useState(100);

  useEffect(() => {
    const handleScroll = () => setScroll(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => animateScroll.scrollToTop();

  // Helper function to build links using the base path
  const buildLink = (path) => `${process.env.PUBLIC_URL}${path}`;

  return (
    <footer
      className={`footer-area ${theme === "blue" ? "footer--2" : "footer--1"}`}
    >
      <div
        className={`dg__footer__container ${
          theme === "blue" ? "bg--blue" : "bg__color--2"
        }`}
      >
        <div className="container">
          <div className="row gy-4">
            {/* Column 1: Trading Accounts */}
            <div className="col-lg-2 col-md-4 col-sm-6">
              <div className="footer__widget">
                <h4>Trading Accounts</h4>
                <ul className="ft__menu">
                  <li>
                    <a href={buildLink("/trading/standard-accounts")}>
                      Standard Accounts
                    </a>
                  </li>
                  <li>
                    <a href={buildLink("/trading/professional-accounts")}>
                      Professional accounts
                    </a>
                  </li>
                  <li>
                    <a href={buildLink("/trading/demo-trading-account")}>
                      Demo trading accounts
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Column 2: Trading Info */}
            <div className="col-lg-2 col-md-4 col-sm-6">
              <div className="footer__widget">
                <h4>Trading Info</h4>
                <ul className="ft__menu">
                  <li>
                    <a href={buildLink("/trading/deposits-and-withdrawals")}>
                      Deposits and withdrawals
                    </a>
                  </li>
                  <li>
                    <a href={buildLink("/trading/fees")}>Fees</a>
                  </li>
                  <li>
                    <a href={buildLink("/trading/client-protection")}>
                      Client protection
                    </a>
                  </li>
                  {/* <li>
                    <a href={buildLink("/trading/order-execution")}>
                      Order execution
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>

            {/* Column 3: Markets */}
            <div className="col-lg-2 col-md-4 col-sm-6">
              <div className="footer__widget">
                <h4>Markets</h4>
                <ul className="ft__menu">
                  <li>
                    <a href={buildLink("/markets/forex-market")}>Forex CFD</a>
                  </li>
                  <li>
                    <a href={buildLink("/markets/commodities-market")}>
                      Commodities CFD
                    </a>
                  </li>
                  <li>
                    <a href={buildLink("/markets/stock-market")}>Stocks CFD</a>
                  </li>
                  <li>
                    <a href={buildLink("/markets/indices-market")}>
                      Indices CFD
                    </a>
                  </li>
                  <li>
                    <a href={buildLink("/markets/crypto-market")}>Crypto CFD</a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Column 4: Platforms */}
            <div className="col-lg-2 col-md-4 col-sm-6">
              <div className="footer__widget">
                <h4>Platforms</h4>
                <ul className="ft__menu">
                  <li>
                    <a href={buildLink("/platforms/pips-terminal")}>
                      Pips Terminal
                    </a>
                  </li>
                  <li>
                    <a href={buildLink("/platforms/pips-trade-app")}>
                      Pips Trade App
                    </a>
                  </li>
                  <li>
                    <a href={buildLink("/platforms/meta-trader-5")}>
                      Meta Trader 5
                    </a>
                  </li>
                  <li>
                    <a href={buildLink("/platforms/meta-trader-4")}>
                      Meta Trader 4
                    </a>
                  </li>
                  <li>
                    <a href={buildLink("/platforms/meta-trader-web-terminal")}>
                      MT Web Terminal
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Column 5: Resources */}
            <div className="col-lg-2 col-md-4 col-sm-6">
              <div className="footer__widget">
                <h4>Resources</h4>
                <ul className="ft__menu">
                  <li>
                    <a href={buildLink("/resources/analytical-tools")}>
                      Analytical Tools
                    </a>
                  </li>
                  <li>
                    <a href={buildLink("/resources/economic-calendar")}>
                      Economic Calendar
                    </a>
                  </li>
                  <li>
                    <a href={buildLink("/resources/trading-calculator")}>
                      Trading Calculator
                    </a>
                  </li>
                  <li>
                    <a href={buildLink("/resources/currency-converter")}>
                      Currency Converter
                    </a>
                  </li>
                  <li>
                    <a href={buildLink("/resources/vps-hosting")}>
                      VPS Hosting
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Column 6: Company & Partners (Combined) */}
            <div className="col-lg-2 col-md-4 col-sm-6">
              <div className="footer__widget">
                <h4>Company</h4>
                <ul className="ft__menu">
                  <li>
                    <a href={buildLink("/company/about")}>About Us</a>
                  </li>
                  <li>
                    <a href={buildLink("/company/contact")}>Contact Us</a>
                  </li>
                  {/* Partners link */}
                  <li>
                    <a href={buildLink("/partners")}>Partners</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="dg__footer__p mt-5">
            <p>
              At The Pips, we’re committed to offering traders a fast,
              transparent, and reliable trading experience. Withdrawal times may
              vary depending on the payment method and banking hours, but we
              always aim to process requests promptly and efficiently.
            </p>
            <p>
              Trading conditions, including spreads, execution speed, and
              pricing, can fluctuate based on market volatility, liquidity, and
              economic events. While we strive to provide accurate and timely
              execution, occasional delays or slippage may occur during periods
              of high market activity.
            </p>
            <p>
              Please note that all trading involves risk. Market movements are
              influenced by global factors, and past performance or statistics
              should not be taken as a guarantee of future results.
            </p>
          </div>
        </div>
        {/* Copyright */}
        <div
          className={`copyright ${theme === "blue" ? "bg--blue" : "bg--black"}`}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-sm-6 col-12">
                <div className="copyright__inner">
                  <p className="copyright-text">
                    &copy; Copyright 2025 - Company
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-sm-6 col-12">
                <ul className="footer__right social__icon">
                  <li>
                    <a
                      href="//facebook.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebookSquare />
                    </a>
                  </li>
                  <li>
                    <a
                      href="//linkedin.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLinkedin />
                    </a>
                  </li>
                  <li>
                    <a
                      href="//twitter.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaTwitterSquare />
                    </a>
                  </li>
                  <li>
                    <a
                      href="//vimeo.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaVimeoSquare />
                    </a>
                  </li>
                  <li>
                    <a
                      href="//tumblr.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaTumblrSquare />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll To Top */}
      <button
        className={`scroll-top ${scroll > top ? "show" : ""}`}
        onClick={scrollToTop}
      >
        <MdExpandLess />
      </button>
    </footer>
  );
};

export default Footer;
